import React from "react";
import { Button } from "@chakra-ui/react";

export default (props: any) => <Button colorScheme="brand" {...props} />;
